<template>
  <div
    class="modal fade"
    :class="{ show: showModal }"
    style="background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content general">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  props: {
    showModal: { type: Boolean, require: true },
  },
};
</script>

<style>
.show {
  display: block !important;
}

.modal-refine {
  height: auto;
}

.general {
  background-color: white;
  width: 350px !important;
  height: 350px !important;
}
</style>
